<template>
  <router-view />
</template>
<script>
  import config from './config';
  import Store from './common/js/store';

  export default {
    created() {
      // 设置api地址
      this.setConfig();

      document.title = this.$t('login.head');
    },
    methods: {
      // 设置config
      setConfig() {
        let [uri, u] = [];
        // 本地调试
        if(process.env.NODE_ENV === 'development') {
          u = 'qa.qfpay.net';
          uri = {
            host: `https://sh.${u}`,
            // host: `http://192.168.0.130:9099`,
            // host: `http://172.100.108.211:9099`,
            oHost: `https://o.${u}`,
            // oHost: `http://172.100.108.190:7200`,
            payHost: `https://openapi.${u}`
          };
        }else {
          // 香港环境
          uri = Store.get('hosts') || {
            host: `https://sh.qfpay.com`,
            oHost: `https://o.qfpay.com`,
            payHost: `https://openapi.qfpay.com`
          };

        }
        Object.assign(config, uri);
      },
    }
  }
</script>



// WEBPACK FOOTER //
// App.vue?3b10742a